import { AuthenticatedApiClient, ScopeType } from '@guiker/payment-shared'
import { AuthLevel, generateBaseApiContext } from '@guiker/react-framework'
import { isScope, Scope } from '@guiker/shared-framework'

type FetchArg = { invoiceId: string } | { scope: Scope<ScopeType> }

export const {
  useContext: useAuthenticatedInvoiceContext,
  Context: AuthenticatedInvoiceContext,
  ContextProvider: AuthenticatedInvoiceContextProvider,
  NestedRouter: AuthenticatedInvoiceNestedRouter,
} = generateBaseApiContext({
  authLevel: AuthLevel.AUTH,
  apiClientGen: AuthenticatedApiClient,
  cacheKey: (fetchArg: FetchArg) => `readOneInvoice-${JSON.stringify(fetchArg)}`,
  fetcher: (apiClient, fetchArg: FetchArg) => {
    if (isScope(fetchArg)) {
      return apiClient.readLastInvoiceByScope({
        pathParams: { scopeType: fetchArg.scope.type, scopeId: fetchArg.scope.id },
      })
    } else {
      return apiClient.readOneInvoice({ pathParams: { invoiceId: fetchArg.invoiceId } })
    }
  },
})
